export const contextRemittance = {
    filter: {
        bank: {
            label: "Banque du réglement",
            placeholder: "ex : Société géniale",
            title: "Saisissez des caractères pour filtrer les factures par leur banque"
        }
    }
}